var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "menubuilder", attrs: { id: "menubuilder" } },
    [
      _c(
        "div",
        { staticClass: "menubuilder__container" },
        [
          _c("LogoUpload"),
          _vm._v(" "),
          _c("CoffeeSelector"),
          _vm._v(" "),
          _c("CustomCoffeeSelector"),
          _vm._v(" "),
          _c("ExtrasSelector"),
          _vm._v(" "),
          _c("TeaSelector"),
          _vm._v(" "),
          _c("OtherSelector"),
          _vm._v(" "),
          _c("CertificationSelector"),
          _vm._v(" "),
          _c("FinalForm", { on: { preview: _vm.togglePreviewPopup } }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "Modal",
        {
          attrs: {
            title: "Menu Preview",
            className: "wide",
            isOpen: _vm.previewPopupOpen,
          },
          on: { toggle: _vm.togglePreviewPopup },
        },
        [
          _c("embed", {
            staticStyle: { "min-height": "calc(100vh - 200px)" },
            attrs: { width: "100%", height: "100%", src: _vm.iframedata },
          }),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./scripts/vue/components/MenuBuilder/MenuBuilder.vue